import { ReferralUser } from '@fable/types'
import { getReferralName } from 'app/social/helpers'
import { useCallback, useEffect } from 'react'
import { useQuery } from 'react-query'
import { getReferralId } from 'utils'
import { useTypedSelector } from './useTypedSelector'
import { useDeeplinkModal } from 'components/app_deep_link_modal'
import { css } from '@fable/theme'

export const useLoadReferral = ({
  enabled = false,
}: { enabled?: boolean } = {}) => {
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { id, storedId, key } = getReferralId({ enabled })
  const { openDeeplinkModal } = useDeeplinkModal()
  const hasReferralId = !!id

  const handleWelcomeRedirect = useCallback(() => {
    if (!!storedId && isAuthenticated) {
      localStorage.removeItem(key)
      openDeeplinkModal({
        hideSMS: true,
        description: 'Download the app to claim your $5 credit.',
        descriptionStyles: css`
          max-width: 352px;
        `,
      })
    }
  }, [isAuthenticated, key, storedId, openDeeplinkModal])

  useEffect(() => {
    handleWelcomeRedirect()
  }, [handleWelcomeRedirect])

  const { data } = useQuery('referral', () => getReferralName(id as string), {
    enabled: hasReferralId,
    retry: false,
  })

  const referralUser = data?.data as ReferralUser

  return {
    hasReferralId,
    referralUser,
    enabled: hasReferralId && !!referralUser,
  }
}
